import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContableSolesFormGroup = ({ iValue, iError, iTouched, setFieldValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('cuentaContableSoles', salida.value)
      setFieldValue('cuentaContableSolesInfo', salida.label)
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContableSoles', '')
    setFieldValue('cuentaContableSolesInfo', '')
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label
        text='CUENTA SOLES'
        htmlFor='select-cuentaContableSoles'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='cuentaContableSoles' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select-cuentaContableSoles' onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableSolesFormGroup)
